import React, { Component } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import { Grid, Typography } from "@mui/material";

class GraceAnointingPage extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid position-relative p-0">
          <MenuBar />
        </div>
        <div>
          {/* Title Section with Overlay */}
          <div className="container-fluid p-0">
            <div
              className="banner-image"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/First-Saturday-Bible-Convention-Banner.jpg)`,
              }}
            >
              <div className="banner-heading text-center wow fadeInDown">
                <h1 className="text-white">Grace Anointing Ministries</h1>
              </div>
            </div>
          </div>

          <div className="container mt-4 mb-5">
            {/* Alternating Image and Text Sections */}
            <Grid container spacing={4}>
              {/* First Row */}
              <Grid item xs={12} md={6}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/sideview.png`}
                  alt="International Retreat"
                />
              </Grid>
              <Grid item xs={12} md={6} container alignItems="center">
                <p>
                  The Holy Spirit forms the core of the ministry. When invoked,
                  the Spirit acts in many mysterious ways. The Holy Spirit has
                  transformed many non-believers into believers, touching the
                  lives of those involved in the ministry. Fr Dominic, the
                  spiritual father of the group, provides guidance, and many
                  have had their lives changed by the grace and deliverance
                  received through him.
                </p>
              </Grid>

              {/* Second Row */}
              <Grid item xs={12} md={6} order={{ xs: 1, md: 0 }}>
                <p>
                  Today, the Grace Anointing ministry of Marian Retreat Centre
                  has expanded to over sixty countries worldwide, with another
                  36 countries served online. The Holy Spirit guides Rev. Fr.
                  Dominic in ministering to people both in India and abroad. As
                  John 8:36 says, “So if the Son sets you free, you will truly
                  be free.” Retreats and conventions are conducted in these
                  countries, supported by a dedicated team of over 400 committed
                  volunteers who help organize events globally. Residential
                  Retreats, International Conventions and Sabbath Prayers are
                  being arranged across the world.
                </p>
              </Grid>
              <Grid item xs={12} md={6} order={{ xs: 0, md: 1 }}>
                <img
                  className="img-fluid shadow-sm"
                  src={`${process.env.PUBLIC_URL}/images/miami1.png`}
                  alt="International Retreat"
                />
              </Grid>
            </Grid>
          </div>
        </div>

        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default GraceAnointingPage;
